module.exports = __webpack_public_path__ + "static/keysight-6ae46382c7f867d4d7eaa1044089106c.png";